import { jsx } from 'react/jsx-runtime';
import { createContext, useState, useCallback, useMemo } from 'react';

const TableFiltersContext = /*#__PURE__*/ createContext({
    filters: {},
    setFilter: ()=>null,
    clear: ()=>null,
    reset: ()=>null
});
/**
 * Filters Provider.
 */ function FiltersContextProvider({ children, initialValues, excludedValues, onChange, values: controlledFilterValues }) {
    const [filters, setFilters] = useState(initialValues ?? {});
    const [excluded, setExcluded] = useState(excludedValues ?? {});
    // Update Filters
    const setFilter = useCallback((name, value, self = false)=>{
        // if filters is controlled, skip internal state changes.
        if (controlledFilterValues) {
            return onChange?.({
                ...controlledFilterValues,
                [name]: value
            });
        }
        // Keep the self handled state as excluded,
        // So we can return it later for the controlled state of the Sub-Components
        if (self) {
            setExcluded((prevState)=>({
                    ...prevState,
                    [name]: value
                }));
        } else {
            setFilters((prevState)=>{
                // Create new state
                const nextState = {
                    ...prevState,
                    [name]: value
                };
                // Call on change with the new state
                onChange?.(nextState);
                // Update the new state
                return nextState;
            });
        }
    }, [
        controlledFilterValues,
        onChange
    ]);
    const clear = useCallback(()=>{
        setFilters({});
        setExcluded({});
        onChange?.({});
    }, [
        onChange
    ]);
    const reset = useCallback(()=>{
        setFilters(initialValues ?? {});
        setExcluded(excludedValues ?? {});
        onChange?.(initialValues ?? {});
    }, [
        initialValues,
        excludedValues,
        onChange
    ]);
    // Provider Values
    const values = useMemo(()=>({
            filters: controlledFilterValues ? controlledFilterValues : {
                ...filters,
                ...excluded
            },
            setFilter,
            clear,
            reset
        }), [
        controlledFilterValues,
        filters,
        excluded,
        setFilter,
        clear,
        reset
    ]);
    return jsx(TableFiltersContext.Provider, {
        value: values,
        children: children
    });
}

export { FiltersContextProvider, TableFiltersContext };
//# sourceMappingURL=TableFilters.Context.es.js.map
